import React, { ReactElement } from 'react';
import { Message } from 'slovlex-idsk-react-components';
import useClientStatusContext from '../../context/ClientStatusContext/context/useClientStatusContext';
import { ClientStatusError } from '../../model/ClientStatusError';
import { ClientStatus } from '../../model/ClientStatus';
import useScrollToErrorMessage from './hook/useScrollToErrorMessage';

const getErrorMessageKey = (error: ClientStatusError, index: number): string => (
  error.fieldName || `${error.message} - ${index}`
);

const getErrorMessageForResponseCode = (status: ClientStatus): string => {
  if (status.responseCode >= 500) {
    return 'Z technických príčin nebolo možné vykonať požadovanú akciu. Prosím, zopakujte '
      + 'požiadavku neskôr alebo kontaktujte Helpdesk Slov-Lex.';
  }
  return null;
};

const GlobalErrors = (): ReactElement => {
  const {
    status,
    clearGeneralErrorMessage,
    clearStatus,
  } = useClientStatusContext();
  useScrollToErrorMessage(status);

  const generalErrorMessages: ReactElement = (
    <div>
      {status && status.generalErrors.map((error, index) => (
        <Message
          className="client-error-message"
          headingSize="m"
          key={getErrorMessageKey(error, index)}
          type="error"
          onClear={() => clearGeneralErrorMessage(error.message)}
        >
          { error.message }
        </Message>
      ))}
    </div>
  );

  const unexpectedErrorMessages: ReactElement = (
    status && getErrorMessageForResponseCode(status) ? (
      <Message
        className="client-error-message"
        key="general-error"
        type="error"
        onClear={clearStatus}
        headingSize="m"
      >
        { getErrorMessageForResponseCode(status) }
      </Message>
    ) : null
  );

  return status?.generalErrors.length ? generalErrorMessages : unexpectedErrorMessages;
};

export default GlobalErrors;
